import { createFileRoute } from "@tanstack/react-router";

import { DismissibleAlert } from "@/components/base/dismissible-alert";
import { Link } from "@/components/base/link";
import { title } from "@/components/base/primitives";
import { ForgotPasswordPhoneForm } from "@/components/users/forgot-password-phone-form";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/account/forgot-password/phone")({
  head: () => ({
    meta: [{ title: "Forgot Password" }],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DefaultLayout>
      <div className="mx-auto flex max-w-xl flex-col space-y-6 text-center">
        <h1 className={title({ size: "lg" })}>Forgot your password?</h1>

        <p className="mx-auto max-w-md">
          Fill out the form below and we'll send you text message with a
          verification code.
        </p>
      </div>

      <div className="mx-auto flex w-full max-w-sm flex-col space-y-4 px-3">
        <DismissibleAlert
          dismissKey="forgot-password-phone-info"
          color="info"
          title="Phone Verification Notice"
          description={
            <div className="flex flex-col gap-y-2">
              <p>
                This option is only available for phone numbers that were
                previously verified in our system.
              </p>
              <p>If you're not receiving a text message, you may have:</p>
              <ul className="list-inside list-disc">
                <li>Not previously verified your phone number</li>
                <li>Entered your phone number in an unsupported format</li>
              </ul>
              <p>
                If you're unable to receive text messages, please{" "}
                <Link
                  to="/account/forgot-password/email"
                  className="font-medium underline"
                >
                  reset your password via email
                </Link>{" "}
                instead.
              </p>
            </div>
          }
        />
      </div>

      <ForgotPasswordPhoneForm className="mx-auto w-full max-w-sm rounded-lg bg-white p-8" />

      <p className="mt-4 text-center text-gray-600">
        <Link to="/account/forgot-password/email">
          Receive an email instead
        </Link>
      </p>
    </DefaultLayout>
  );
}
